import React, { useEffect } from 'react';
import { useState } from 'react';
import './index.scss';
import { isH5HandleClient } from 'eco-design-micro/utils-base/isH5Handle';
import TypeContent from '../TypeContent';

interface Props {
    prefixCls: string;
    item: any;
}

const CardTypeA: React.FC<Props> = ({ prefixCls, item }) => {
    const [activeIndex, setActiveIndex] = useState(0);

    const lItems = item.subs || [];
    const activeItemB = lItems[activeIndex] || {};

    const [lineStyle, setLineStyle] = useState({
        width: 0,
        translateX: 0,
    });
    useEffect(() => {
        if (typeof window === 'undefined') return;
        if (isH5HandleClient()) return;
        const target = document.querySelector(`.${prefixCls}-card-type-a__tabs-item.active`) as HTMLDivElement;
        if (!target) return;
        setLineStyle({
            width: target.offsetWidth,
            translateX: target.offsetLeft,
        });
    }, [activeIndex, prefixCls]);
    if (lItems.length === 0) return <div className={`${prefixCls}-card-type-a`}></div>;
    return (
        <div className={`${prefixCls}-card-type-a`}>
            <div className={`${prefixCls}-card-type-a__tabs`}>
                {lItems.map((i: any, idx: number) => (
                    <div
                        className={`${prefixCls}-card-type-a__tabs-item-content ${
                            activeIndex === idx ? `${prefixCls}-card-type-a__tabs-item-content-active` : ''
                        }`}
                        key={idx}
                    >
                        <div
                            className={`${prefixCls}-card-type-a__tabs-item ${activeIndex === idx ? 'active' : ''}`}
                            onClick={() => (isH5HandleClient() ? setActiveIndex(idx === activeIndex ? -1 : idx) : setActiveIndex(idx))}
                        >
                            {i.name}
                        </div>
                        <TypeContent prefixCls={prefixCls} activeItemB={activeItemB} isH5 active={activeIndex === idx} />
                    </div>
                ))}

                {/* 选中线条 */}
                <div
                    className={`${prefixCls}-card-type-a__tabs-line`}
                    style={{
                        width: lineStyle.width,
                        transform: `translateX(${lineStyle.translateX}px)`,
                    }}
                ></div>
            </div>
            <TypeContent prefixCls={prefixCls} activeItemB={activeItemB} />
        </div>
    );
};
export default CardTypeA;
